<template>
  <moderator-detail :moderator="moderator"></moderator-detail>
</template>

<script>
import store from "@/store";
import ModeratorDetail from "@/components/Moderator/Detail";

export default {
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("user/read", [
        {
          name: "where",
          attributes: {
            id: [Number(to.params.id)]
          }
        },
        {
          name: "with",
          value: ["moderatorProfile", "moderatorProfile.agency"]
        }
      ])
      .then(() => {
        next();
      })
      .catch(() => {
        next("/");
      });
  },
  components: {
    ModeratorDetail
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    moderator() {
      return this.$store.getters["user/find"](this.id);
    }
  }
};
</script>
